export const AntiScrapingComponent = () => {
    document.title = "PocketQuant | Anti-Scraping Policy";

    return (
        <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                <a href="/">
                    <img
                        className="mx-auto h-20 rounded-lg w-auto"
                        src="pq-icon-512.png"
                        alt="PocketQuant Logo"
                    />
                </a>
                <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                    Privacy Policy
                </h2>
            </div>

            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                <div className="space-y-6">
                    <p>
                        Anti-Scraping Terms and Conditions
                        PocketQuant, establishes the guidelines and rules for the use of any content made available by us and prohibits unauthorized scraping activities. By accessing or using any content provided by us, you agree to these Terms. We guide the reading carefully.
                    </p>

                    <p>
                        1. Definitions
                        <br />
                        1.1. Scraping refers to the practice of automatically collecting, through tools and other mechanisms, information from a website or online resource, commonly without the permission of the website owner.
                        <br />
                        1.2. User: You, the person or entity that accesses, uses, or attempts to access or use any content provided by us.
                    </p>

                    <p>
                        2. Prohibition of Unauthorized Scraping
                        <br />
                        2.1. You agree not to engage in unauthorized scraping of any content made available by us. This includes the collection, copying, distribution, display, publication, or any other way of obtaining information from our resources in an automated manner without our express authorization.
                    </p>

                    <p>
                        3. Authorized Use
                        <br />
                        3.1. Any authorized use of the content provided by Us will be made expressly and unequivocally. The authorized use will be subject to specific terms and conditions that will be provided for in its own document.
                    </p>

                    <p>
                        4. Detection and Consequences
                        <br />
                        4.1. Considering that we adopt absolute and totally contrary conduct to the practice of scraping, there will be no tolerance or conditional when identifying this practice by the user, so we will not hesitate to take the appropriate measures within our reach.
                        <br />
                        4.2. We reserve the right to monitor, detect and respond to unauthorized scraping activities. This may include blocking IP addresses, unsubscribing, blocking accounts and among other measures to prevent the continuation of these activities.
                        <br />
                        4.3. Violation of these Terms will subject you to legal action, including, but not limited to, lawsuits to enforce our rights and seek compensation for damages, both in civil and criminal matters.
                        <br />
                        4.4. The user declares himself aware that, by identifying the scraping practice, we may share the user's access data (IP, user agent, location and others) with third parties if necessary for practice analysis purposes.
                    </p>

                    <p>
                        5. Complaints and Notification of Violation
                        <br />
                        5.1. If you believe that unauthorized scraping of our content is occurring, please contact us at the following email address: contato@fundamentei.com. We will take the recommended measures to investigate and correct any detected violation.
                    </p>

                    <p>
                        6. Changes to the Terms
                        <br />
                        6.1. We reserve the right to change these Terms at any time. Any changes will be published on our website or through other forms of communication. The continued use of our content after the implementation of changes will mean your acceptance of these changes.
                    </p>

                    <p>
                        7. Conclusion
                        <br />
                        7.1. This Term constitutes the entire agreement between you and Us regarding the use of our content and the prohibition of unauthorized scraping. They replace all previous or contemporary communications, written or oral.
                        <br />
                        7.2. This Term is governed by the laws of Canada, respecting all other laws and international treaties in which Canada participates, and any disputes arising from or related to them will be subject to the exclusive jurisdiction of the courts of that jurisdiction.
                        <br />
                        By accepting these terms, you acknowledge that you have understood and agree to comply with the rules and guidelines regarding the use of our content and the prohibition of unauthorized scraping. Failure to comply with these terms may result in legal consequences.
                    </p>

                </div>
            </div>
        </div>
    )
}